import React from 'react';
import { Loader2 } from 'lucide-react';
import { StepLayout } from './steps/step-layout';

export function ChatLoading() {
  return (
    <StepLayout
      icon={<Loader2 size={10} className="text-blue-500 animate-spin" strokeWidth={2.5} />}
      title={<span className="text-gray-500 italic">Processing</span>}
      summary="Generating response..."
      hasContent={false}
      isStreaming={true}
    />
  );
}
